<template>
  <div>
    <div class="tabs">
      <router-link v-for="(data, index) in options" :key="index"
            :to="({name: data.route})">
        {{data.name}}
      </router-link>
    </div>

    <router-view />
  </div>
</template>

<script>
export default {
  name: 'SettingsTabs',
  data () {
    return {
      options: []
    }
  },
  created () {
    this.populateData()
  },
  methods: {
    populateData () {
      this.options = [
        {
          name: 'Status',
          route: 'BeneBankStatus'
        },
        {
          name: 'History',
          route: 'BeneBankHistory'
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/mixins';

  .tabs {
    @include custom-flex();
    width: 100%;
    margin-bottom: 15px;

    a {
      padding: 10px;
      color: $grey-text !important;
      border-bottom: 2px solid $grey-outline;
      flex: 1;
      font-size: 14px;

      &.router-link-exact-active {
        color: $primary !important;
        border-bottom: 2px solid $primary !important;
        font-weight: 500;
      }

      &:hover {
        color: $grey-text;
      }
    }
  }
</style>
